import { Model } from 'modules/core/lib/mobx-rest'

export interface IAccessGroupMembership {
  id: number
  access_id: number
  access_group_id: number
  created_at: string
  updated_at: string
}

/**
 * @deprecated Do not use the generic access group membership model, we're removing it from the API. Create a domain specific entity instead.
 */
class AccessGroupMembership extends Model<IAccessGroupMembership> {
  static urlRoot() {
    return '/access_group_memberships'
  }

  get indexes() {
    return ['access_id', 'access_group_id']
  }

  async update(_attributes: unknown, _saveOptions: unknown = {}) {
    throw new Error("Can't modify generic access group memberships through the API")
  }

  async save(_attributes: unknown, _saveOptions: unknown = {}) {
    throw new Error("Can't modify generic access group memberships through the API")
  }

  async delete(_destroyOptions: unknown) {
    throw new Error("Can't modify generic access group memberships through the API")
  }

  async destroy(_destroyOptions: unknown) {
    throw new Error("Can't modify generic access group memberships through the API")
  }

  rpc(_endpoint: unknown, _options: unknown): Promise<never> {
    throw new Error("Can't modify generic access group memberships through the API")
  }
}

export default AccessGroupMembership
